import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Block, DefaultText, MediumText } from '@guryou/html-components';
import { CREATE_SESSION, PROVIDER_GET_CLASSES, resetState, stateIsLoading, useGender, useServiceCategories } from '@guryou/redux';
import GenderRadio from 'onboard/components/GenderRadio';
import CheckboxInfoContainer from 'onboard/containers/CheckboxInfoContainer';
import FormContainer from 'onboard/containers/FormContainer';
import InfoContainer from 'onboard/containers/InfoContainer';
import MainContainer from 'onboard/containers/MainContainer';
import PlayGuideVideoEmbed from 'onboard/containers/PlayGuideVideoEmbed';
import TitleContainer from 'onboard/containers/TitleContainer';
import { useOnboardContext } from 'onboard/context';
import { guideVideos } from 'onboard/GuideVideosUrls';
import { dealTokens, SystemFormGrid, SystemSelect, SystemTextArea, SystemTextInput } from 'components/shared';

import StepButtons from '../StepButtons';

const getRecurring = type => {
  if (type === 'service') {
    return 'N';
  }
  if (type === 'course') {
    return 'Y';
  }
  if (type === 'event') {
    return 'E';
  }
  return null;
};

const CourseGeneralInformation = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { courseState, setCourseState, serviceType } = useOnboardContext();
  const genderOptions = useGender(true);

  const categories = useServiceCategories({ type: serviceType });

  const handleSubmit = data => {
    setCourseState({ ...data, recurring: getRecurring(serviceType), type: serviceType });
    dispatch(resetState(CREATE_SESSION));
    dispatch(resetState(PROVIDER_GET_CLASSES));
  };

  return (
    <MainContainer>
      <FormContainer handleSubmit={handleSubmit}>
        <TitleContainer title={t(`ONBOARD.${serviceType}Title`)} />
        <Block lg={10} md={12} xs={12} margin={0} marginTop={6}>
          <SystemFormGrid singleColumn>
            <SystemTextInput label={t(`ONBOARD.${serviceType}Name`)} name="serviceName" value={courseState.serviceName} required />
            <SystemTextArea rows={6} required name="description" label={t('ONBOARD.description')} value={courseState.description} />
            <SystemSelect
              name="svcTypeId"
              disabled={stateIsLoading(categories)}
              required
              label={t('ONBOARD.category')}
              value={courseState.svcTypeId}
              none={false}
              options={categories?.data}
            />
          </SystemFormGrid>
          <GenderRadio options={genderOptions} value={courseState.target} />
        </Block>
        <StepButtons />
      </FormContainer>
      <InfoContainer>
        <MediumText lineHeight="1.3">{t('ONBOARD_TEXT.courseGeneralInformationTitle')}</MediumText>
        <DefaultText color={dealTokens.color.textMuted} marginTop={2}>
          {t('ONBOARD_TEXT.courseGeneralInformationSubtitle')}
        </DefaultText>

        <div style={{ marginTop: dealTokens.space[6], paddingTop: dealTokens.space[5], borderTop: `1px solid ${dealTokens.color.border}` }}>
          <div
            style={{
              fontSize: 11,
              fontWeight: dealTokens.font.weightSemibold,
              letterSpacing: '0.06em',
              textTransform: 'uppercase',
              color: dealTokens.color.textMuted,
              marginBottom: dealTokens.space[4],
            }}
          >
            {t('ONBOARD_TEXT.courseGeneralInformationCheckboxTitle')}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: dealTokens.space[4] }}>
            <CheckboxInfoContainer text={t('ONBOARD_TEXT.courseGeneralInformationCheckbox1Text')} />
            <CheckboxInfoContainer text={t('ONBOARD_TEXT.courseGeneralInformationCheckbox2Text')} />
            <CheckboxInfoContainer text={t('ONBOARD_TEXT.courseGeneralInformationCheckbox3Text')} />
          </div>
        </div>

        <PlayGuideVideoEmbed videoId={guideVideos[`${serviceType}GeneralInfo`].videoId} modalTitle={guideVideos[`${serviceType}GeneralInfo`].title} />
      </InfoContainer>
    </MainContainer>
  );
};

export default CourseGeneralInformation;
